import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { TabFilesDatagrid } from '../../../components/fileManager/TabFilesDatagrid';
import { DetailPageParams } from '../../../types/pageParams.types';
import { ITab } from '../AssetsEdit';

interface Props extends ITab {
  isReadonly: boolean;
  onFileCountChange: () => void;
}

/**
 * Záložka pro spárvu souborů v assetech. Pro správu assetů se použvá shared component. Tato komponenta slouží
 * pouze jako wrapper, aby byla zachována struktura tabů.
 * @constructor
 */
export function AssetTabFiles({ active, isReadonly, onFileCountChange }: Props) {
  const { id } = useParams<DetailPageParams>();

  useEffect(() => {}, [active]);
  return (
    <TabFilesDatagrid
      id={id as unknown as number}
      entityName="Asset"
      isReadonly={isReadonly}
      onFileCountChange={onFileCountChange}
      mainEntity={'asset'}
    />
  );
}
